import {
  ClassName,
  I18nText,
  IsLoading,
  ErrorMessage,
  IsDisabled,
  GADataType
} from '../../../../../types';

import { SelectProjectAndTaskModalButtonOnSubmitAction } from './SelectProjectAndTaskModalButton.types';

import { useSelectProjectAndTaskForm } from '../../forms/SelectProjectAndTaskForm/hooks/useSelectProjectAndTaskForm';
import { useSelectProjectAndTaskFormSelectedTaskEmptyValue } from '../../forms/SelectProjectAndTaskForm/hooks/useSelectProjectAndTaskFormSelectedTaskEmptyValue';

import { SelectProjectAndTaskForm } from '../../forms/SelectProjectAndTaskForm';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { FormModalButton } from '../../../../../helpers/buttons/FormModalButton';
import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

import { IconsEnum } from '../../../../../assets/icons/types';

interface SelectProjectAndTaskModalButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  i18nSubmitText?: I18nText;
  i18nTitle?: I18nText;
  i18nTextClassName?: ClassName;
  isLoading?: IsLoading;
  submitDisabled?: IsDisabled;
  errorMessage?: ErrorMessage;
  onClose?: () => void;
  onSubmit: SelectProjectAndTaskModalButtonOnSubmitAction;
  iconClassName?: ClassName;
  icon?: IconsEnum;
  tooltipSingleton?: boolean;
  tooltipPlacement?: TooltipPlacement;
  tooltipI18nText?: I18nText;
  disabled?: boolean;
}

const SELECT_PROJECT_AND_TASK_FORM = 'select-project-and-task-form';

function SelectProjectAndTaskModalButton({
  className,
  dataGa,
  disabled,
  errorMessage,
  i18nSubmitText,
  i18nText,
  i18nTitle,
  i18nTextClassName,
  icon,
  iconClassName,
  isLoading,
  onClose,
  onSubmit,
  submitDisabled,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: SelectProjectAndTaskModalButtonProps & GADataType) {
  const selectedTaskEmptyValue =
    useSelectProjectAndTaskFormSelectedTaskEmptyValue();

  const {
    control,
    resetForm,
    handleSelectProjectAndTask,
    watchSelectedProjectUuid
  } = useSelectProjectAndTaskForm({
    onSubmit,
    selectedTaskEmptyValue
  });

  return (
    <FormModalButton
      className={className}
      dataGa={dataGa}
      disabled={disabled}
      form={SELECT_PROJECT_AND_TASK_FORM}
      i18nSubmitText={i18nSubmitText}
      i18nText={i18nText}
      i18nTextClassName={i18nTextClassName}
      i18nTitle={i18nTitle}
      icon={icon}
      iconClassName={iconClassName}
      isLoading={isLoading}
      onClose={onClose}
      onOpen={resetForm}
      onSubmit={handleSelectProjectAndTask}
      submitDisabled={submitDisabled}
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    >
      <SelectProjectAndTaskForm
        form={SELECT_PROJECT_AND_TASK_FORM}
        control={control}
        isLoading={isLoading}
        watchSelectedProjectUuid={watchSelectedProjectUuid}
        selectedTaskEmptyValue={selectedTaskEmptyValue}
      />

      <div className="px-4">
        <AlertMessage message={errorMessage} />
      </div>
    </FormModalButton>
  );
}

export default SelectProjectAndTaskModalButton;
